import { useMemo, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import {
  ButtonBase,
  Card,
  Stack,
  Link,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  TextField,
} from '@mui/material';
// hooks
import { AnimatePresence, m } from 'framer-motion';
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
// sections
import { LoginForm } from '../../sections/auth/login';
import { USERTYPES } from '../../config';
import { varSlide } from '../../components/animate';
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  // zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  // minHeight: '70vh',
  display: 'flex',
  // justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(4, 0),
}));

// ----------------------------------------------------------------------

export default function AdminLogin() {
  const { method } = useAuth();

  const { translate } = useLocales();

  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <RootStyle>
        <img
          src={require('../../assets/casino_bg.jpg')}
          alt="Login BG"
          style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, width: '100%', height: '100%' }}
        />
        <HeaderStyle>
          <Logo />
        </HeaderStyle>

        <Card
          component={Container}
          maxWidth="sm"
          sx={{ background: 'rgb(33, 43, 54)', borderRadius: '5px', width: { md: '100%', sm: '80%', xs: '80%' } }}
        >
          <ContentStyle>
            <Typography variant="h3" sx={{ textAlign: 'center', mb: 2, color: '#fff' }}>
              {translate('login')}
            </Typography>

            <LoginForm />
          </ContentStyle>
        </Card>
      </RootStyle>
    </Page>
  );
}
